import { FormattedText } from '~/Features/Txt/TxtBase';

export const getPointsLabel = (messageFormat: string, points: number) =>
    points <= 0 ? undefined : FormattedText(messageFormat, { points });
